import React from "react";
import R14, {
  Text,
  DataTable,
  Platform,
  View,
  SafeAreaView,
  Image,
} from "../core";
import Touchable from "./TouchableComponent";
import NoRecordsFound from "./NoRecordsFound";
import CommonUtility from "../utils/CommonUtility";
import DateUtils from "../utils/DateUtils";
import { commonStyles } from "../assets/css/commonStyle";
import { gridTableStyles } from "../assets/css/gridTableStyles";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import { BILL_STATUS, } from "../constant/app.data.constant";
import StatusComponent from "./StatusComponent";
import Bookmarked from "./Bookmared";
import FilterComponent from "../components/FilterComponent";

import removeFilterIcon from "../assets/images/NewRemoveFilterIcon.png";
export default R14.connect(
  class ViewAllBillsGridTableComponent extends React.Component {
    constructor(props) {
      super(props);
      this.handleDeleteClientPress = this.handleDeleteClientPress.bind(this);
      this.handleAddClientPress = this.handleAddClientPress.bind(this);
      this.initializer = this.initializer.bind(this);
      this.pageLoader = this.pageLoader.bind(this);
      this.cellRenderer = this.cellRenderer.bind(this);
      this.rowKeyExtractor = this.rowKeyExtractor.bind(this);
    }

    async initializer(gridState) {
      this.props.app.dm.userSession.setState({isLoading: true});
      const data = await this.props.getPageData(gridState, { totalCount: true });
      this.props.app.dm.userSession.setState({isLoading: false});
      return data;
    }
    async pageLoader(gridState) {
      let res = await this.props.getPageData(gridState, { totalCount: true }, false);
      return res.pageData;
    }
    get dataTable() {
      return this.props.app.ui.dataTable("clients");
    }

    shortenText = (txt = "", limit = 30) => {
      if (!!txt && !isNaN(txt) && !Number.isInteger(+txt)) {
        const num = +txt;
        return num.toFixed(2);
      } else if (!!txt && txt.length > limit) {
        return txt.substring(0, limit) + '...';
      } else {
        return txt;
      }
    };

    getNestedProperty(obj, path) {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }


    renderViewAllBillsCellRenderer(e) {
      const { columns, columnName, row } = e;
      const { amountTypeFields, dateTypeFields, profileIcon, showPayType, CheckPaymentAllowOrNot, toggleBookmark, onProfileIcon } = this.props;
      let text = row[columnName];

      if (columns && columns[columnName] && columns[columnName].label === "Action") {
        return (
          <Touchable onPress={() => showPayType(row)}  style={[gridTableStyles.zIndex2]} disabled={!CheckPaymentAllowOrNot(row)} >
            <View style={[responsiveTableStyle.paynowBtnInnerWrap, customCommonStyles.customPaynowBtnInnerWrap, Platform.OS !== "web" ? commonStyles.paddingTop3 : null, !CheckPaymentAllowOrNot(row) ? customCommonStyles.disabledBtn : null]}>
              <Text style={[commonMetricsStyle.heading6, commonStyles.fontWeight500, commonFontStyles.workSans, commonStyles.textAlignCenter, commonStyles.fullWidth, commonStyles.fontWeight400, commonStyles.exSmallHeading, commonStyles.flex1, commonStyles.justifyContentCenter, commonStyles.alignItemCenter, !CheckPaymentAllowOrNot(row) ? commonStyles.lightGray : commonStyles.whiteColor]}>Pay Now</Text>
            </View>
          </Touchable>
        );
      }

      if (columnName === "bookmark") {
        return <View >
          {!BILL_STATUS[row.billStatus] && !(row.status === "blocked" || row.status === "payerblocked") ? (
            <Bookmarked
              bookedMarkSpacing={responsiveTableStyle.bookedMarkSpacing}
              onToggle={() => {
                toggleBookmark(row);
                this.refreshDataTable();
              }}
              isBookmarked={row.bookmark}
              bookedMarkImgStyle={[commonStyles.marLT0]}
              bookedMarkStyle={[gridTableStyles.btnHeight]}
            />
          ) : null}
        </View>
      }

      if (profileIcon === columnName) {
        if (columnName.includes(".")) text = this.getNestedProperty(row, columnName);
        return (
          <Touchable onPress={() => onProfileIcon(row)}>
          <View style={[commonStyles.flex1, commonStyles.flexDirectionRow]}>
            <View style={[responsiveTableStyle.userIconDiv, commonStyles.flex1, commonStyles.justifyContentCenter, commonStyles.alignItemsCenter, commonStyles.marLT0, commonStyles.marT0, commonStyles.marB0, commonStyles.marginRight5]}>
              <Text
                style={[
                  commonStyles.fontWeight500,
                  commonFontStyles.workSans,
                  commonStyles.exSmallHeading,
                  commonStyles.userInitial,
                  commonStyles.contentColor,
                  responsiveTableStyle.userInitial,
                  commonStyles.dBlock
                ]}>
                {CommonUtility.shortName(`${text}`)}
              </Text>
            </View>
            <Text style={[commonFontStyles.workSans, gridTableStyles.cellText]}>{this.shortenText(text)} </Text>
          </View>
          </Touchable>
        )
      }

      if (!!amountTypeFields && amountTypeFields.length && amountTypeFields.includes(columnName)) {
        text = row[columnName] ? this.shortenText(CommonUtility.formatAmount(row[columnName], this.props.app)) : CommonUtility.formatAmount("0.00", this.props.app);
      } else if (!!dateTypeFields && dateTypeFields.length && dateTypeFields.includes(columnName)) {
        text = DateUtils.dataTableDateFormatter(row[columnName]);
      } else if (columnName.includes(".")) {
        text = this.getNestedProperty(row, columnName)
      }
      return <Text style={[commonFontStyles.workSans, gridTableStyles.cellText]}>{this.shortenText(text)} </Text>
    }

    cellRenderer(e) {
      return this.renderViewAllBillsCellRenderer(e);
    }
    rowKeyExtractor(row) {
      return row.uid;
    }

    async handleAddClientPress() {
      this.props.app.nav.to("addClientRoute", {
        mode: "add"
      })
    }

    async handleDeleteClientPress(uid) {
      this.props.app.ui.progressIndicator.show();
      this.props.app.ui.progressIndicator.hide({ timeout: 750 });
    }

    async handleBookmarkSyncPress(row, dataTable) {
      await this.props.toggleBookmark(row);
      this.refreshDataTable();
      return false;
    }

    onCheckboxChange = (selectedChk) => {
      this.props.app.dm.filterDomain.setState({ selectedChk });
    };

    onDateChkboxChange = (selectedDateChk) => {
      this.props.app.dm.filterDomain.setState({ selectedDateChk });
    };

    onSwitchChange = (sortOrder) => {
      this.props.app.dm.filterDomain.setState({ sortOrder });
    };

    onStatusChange = async (ind) => {
      const { statusType } = this.props.app.dm.filterDomain.state;
      statusType[ind].isSelected = !statusType[ind].isSelected;
      this.props.app.dm.filterDomain.setState({ statusType });
    };

    refreshDataTable = () => {
      this.dataTable.refresh();
      this.props.app.dm.userSession.setState({isLoading: true});
      return false;
    };

    onCloseFilter = () => {
      const {
        selectedStatus,
        selectedChk,
        sortOrder,
        statusType,
        radioOpt,
        selectedDateChk,
        fromDate,
        toDate
      } = this.props.app.dm.filterDomain.state.oldFilterState;
      this.props.app.dm.filterDomain.setState({
        isFilterOpen: false,
        selectedChk,
        sortOrder,
        statusType,
        radioOpt,
        selectedStatus,
        selectedDateChk,
        fromDate,
        toDate
      });
    };


    onCrossClick = async (el) => {
      let { selectedStatus, statusType } = this.props.app.dm.filterDomain.state;
      statusType.forEach((itm) => {
        if (itm.label.toLowerCase() === el.toLowerCase()) {
          itm.isSelected = false;
        }
      });
      let idx = selectedStatus.indexOf(el);
      if (idx > -1 && !(el === "Date Range" || el === "Biller")) {
        selectedStatus.splice(idx, 1);
        await this.props.app.dm.filterDomain.setState({ selectedStatus: selectedStatus, statusType: statusType });
      } else if (el === "Date Range" || el === "Biller") {
        selectedStatus = selectedStatus.filter(status => status !== el);
        if (el === "Date Range") {
          await this.props.app.dm.filterDomain.setState({ selectedStatus: selectedStatus, selectedDateChk: "billDate", fromDate: null, toDate: null });
        }
        if (el === "Biller") {
          await this.props.app.dm.filterDomain.setState({ selectedStatus: selectedStatus, selectedBU: "" });
        }
      }
      this.refreshDataTable();
    };

    onRestoreFilter = () => {
      this.props.app.dm.filterDomain.resetFilter();
      this.refreshDataTable();
    };

    renderSelectedFilterOpt() {
      const { selectedStatus, showResetFilterBtn } = this.props.app.dm.filterDomain.state;
      const statusOtp = selectedStatus;
      return !!statusOtp && !!statusOtp.length ? (
        <View
          style={[
            commonStyles.flex1,
            commonStyles.flexDirectionRow,
            commonStyles.justifyContentSpaceBetween,
            responsiveTableStyle.filterBySection,
            !!statusOtp && !!statusOtp.length ? responsiveTableStyle.filterBySectionWithFiler : null,
          ]}>
          <View style={[responsiveTableStyle.filtereHading]}>
            <Text style={[responsiveTableStyle.marB10, commonFontStyles.workSans, commonMetricsStyle.heading6, commonStyles.fontWeight600]}>Filter by: </Text>
          </View>
          <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.flexGrow1, commonStyles.flexWrap, commonStyles.alignItemsCenter]}>
            {statusOtp.map((el, ind) => (
              <StatusComponent
                key={ind}
                label={el}
                isSelected={true}
                circleNotAllowed={true}
                hasClose
                marginBottom={[commonStyles.marB0]}
                onCrossClick={() => this.onCrossClick(el)}
                wrapperStyle={[gridTableStyles.statusWrapperStyle]}
              />
            ))}
          </View>
          {!!statusOtp && !!statusOtp.length ? (
            <View tooltip={'Remove All Filters'} style={[commonStyles.marginLeftRight16, commonStyles.marginRight8]}>
                <Touchable onPress={this.onRestoreFilter} hidden={!showResetFilterBtn}>
                  <View>
                    <Image source={removeFilterIcon} style={commonStyles.icon18} />
                  </View>
                </Touchable>
            </View>
          ) : null
          }
        </View>
      ) : null;
    }

    render() {
      const { name, labelKeys, labelValues, message, searchable, rowControlsRight, autoRefresh = 0, headerControlsRight = null, rowsPerPage = 10, headerTitleTextStyle = null } = this.props;
      const columns = {};
      labelKeys.forEach((keyObj, index) => {
        const key = labelValues[index];
        columns[key] = {
          label: keyObj.label,
          ...(keyObj.sortable !== undefined ? { sortable: keyObj.sortable } : {}),
          ...(keyObj.width !== undefined ? { width: keyObj.width } : {}),
          ...(keyObj.cellStyle ? { cellStyle: keyObj.cellStyle } : {})
        };
      });

      const { isFilterOpen, selectedChk, sortOrder, statusType, selectedStatus, radioOpt, selectedDateChk, showResetFilterBtn } = this.props.app.dm.filterDomain.state;
      let option = { selectedChk, sortOrder, statusType, selectedStatus, radioOpt, selectedDateChk, showResetFilterBtn };
      return (
        <SafeAreaView style={[gridTableStyles.screenLayout, commonStyles.widthAuto]}>
          <View style={[responsiveTableStyle.filterBySectionWrapper]}>{this.renderSelectedFilterOpt()}</View>
          <FilterComponent
            isVisible={isFilterOpen}
            defaultFilter={option}
            onCancelFilter={this.onCloseFilter}
            onFilter={this.refreshDataTable}
            onCheckboxChange={this.onCheckboxChange}
            onSwitchChange={this.onSwitchChange}
            onStatusChange={this.onStatusChange}
            billerNameList={this.props.billers}
            onDateChkboxChange={this.onDateChkboxChange}
          />
          <DataTable
            name={name}
            columns={columns}
            searchable={searchable}
            initializer={this.initializer}
            rowKeyExtractor={this.rowKeyExtractor}
            pageLoader={this.pageLoader}
            TableEmptyComponent={<NoRecordsFound noRecords={[commonStyles.marLT0, commonStyles.marRT0]} message={message} />}
            cellRenderer={(e) => this.cellRenderer(e)}
            initialPage={1}
            initialRowsPerPage={rowsPerPage}
            initialTotalRows={rowsPerPage}
            initialSortColumnName='type'
            initialSortDirection='asc'
            // onRowPress={(item) => onProfileIcon(item)}
            autoRefresh={autoRefresh}
            headerControlsRight={headerControlsRight}
            headerTitle={this.props.title || null}
            headerTitleTextStyle={[gridTableStyles.headerTitleTextStyle, headerTitleTextStyle]}
            rowControlsRight={!rowControlsRight ? null : (row, dataTable) => {
              return rowControlsRight
            }}
          /> </SafeAreaView>
      );
    }
  }
);